"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _styledComponents = require("styled-components");
var _GlobalStyles = _interopRequireDefault(require("./GlobalStyles"));
var _themes = _interopRequireDefault(require("../themes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var propTypes = {
  /** Name of the base theme - a theme form Smalt that contains the variables used in all the library's components. */
  baseThemeName: _propTypes["default"].oneOf(["_base", "adr", "aodb", "airturn", "task", "stand", "realtime", "chat"]),
  /** A theme object with overwrites or additions. A `merge` will be performed  */
  theme: _propTypes["default"].object,
  /** When `true` it will include the GlobalStyles component before the children */
  applyGlobalStyles: _propTypes["default"].bool,
  /** Content that is wrapped */
  children: _propTypes["default"].node
};
var CustomThemeProvider = function CustomThemeProvider(_ref) {
  var _ref$baseThemeName = _ref.baseThemeName,
    baseThemeName = _ref$baseThemeName === void 0 ? "_base" : _ref$baseThemeName,
    theme = _ref.theme,
    children = _ref.children,
    _ref$applyGlobalStyle = _ref.applyGlobalStyles,
    applyGlobalStyles = _ref$applyGlobalStyle === void 0 ? true : _ref$applyGlobalStyle;
  var customTheme = (0, _merge["default"])({}, _themes["default"][baseThemeName], theme);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: customTheme
  }, applyGlobalStyles ? /*#__PURE__*/_react["default"].createElement(_GlobalStyles["default"], null) : null, children);
};
CustomThemeProvider.propTypes = propTypes;
CustomThemeProvider.displayName = "ThemeProvider";
var _default = CustomThemeProvider;
exports["default"] = _default;